import React from 'react'
import { Card } from 'antd'

import '../../components/biils/Managebills.css'
import BillsHistoryNoContext from '../../components/biils/BillsHistoryNoContext'

const BillHistory = () => {
  return (
    <Card>
      <BillsHistoryNoContext />
    </Card>
  )
}

export default BillHistory